module.exports = __webpack_public_path__ + "img/list-title-s.58d8000a.png";